/**
 * @generated SignedSource<<16c41107c9fa385d716d669dd1d1e87a>>
 * @relayHash f810da8cea79d71a04fc452742d3a0d8
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

// @relayRequestID f810da8cea79d71a04fc452742d3a0d8

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filename"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "propositionId"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "filename",
        "variableName": "filename"
      },
      {
        "kind": "Variable",
        "name": "propositionId",
        "variableName": "propositionId"
      }
    ],
    "concreteType": "TokenResponse",
    "kind": "LinkedField",
    "name": "convertPropositionCommerciale",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "token",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ConvertPropositionCommercialeMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "ConvertPropositionCommercialeMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "id": "f810da8cea79d71a04fc452742d3a0d8",
    "metadata": {},
    "name": "ConvertPropositionCommercialeMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

node.hash = "c141590c953a0001876f01ec88b0d16b";

export default node;
